"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./attachment"), exports);
__exportStar(require("./common"), exports);
__exportStar(require("./customer"), exports);
__exportStar(require("./dealer"), exports);
__exportStar(require("./employee"), exports);
__exportStar(require("./error"), exports);
__exportStar(require("./margin-vendor-invoice"), exports);
__exportStar(require("./send-sms"), exports);
__exportStar(require("./signing-job"), exports);
__exportStar(require("./vehicle"), exports);
__exportStar(require("./vehicle-order"), exports);
__exportStar(require("./vehicle-order-status"), exports);
__exportStar(require("./vehicle-status"), exports);
__exportStar(require("./vehicle-margin-calculation-budget"), exports);
__exportStar(require("./vehicle-status-bos-entity"), exports);
__exportStar(require("./vehicle-margin-calculation-budget-sales"), exports);
__exportStar(require("./vehicle-margin-calculation-transactions"), exports);
__exportStar(require("./vehicle-margin-calculation-options"), exports);
__exportStar(require("./vehicle-margin-customer-relation"), exports);
__exportStar(require("./vehicle-margin-calculation-actuals"), exports);
__exportStar(require("./vehicle-margin-owner"), exports);
__exportStar(require("./vehicle-margin-overview-details"), exports);
//# sourceMappingURL=index.js.map